// Environment: which Firebase project this build talks to. Set in .env.staging / .env.production
// (committed, public web config) and chosen with `vite build --mode staging|production`.
const need = (k: string): string => {
  const v = import.meta.env[k];
  if (!v) throw new Error(`Missing ${k}. Build with --mode staging or --mode production.`);
  return v as string;
};

export const ENV = {
  name: (import.meta.env.VITE_TV_ENV as 'staging' | 'production' | 'local') ?? 'local',
  firebase: {
    apiKey: need('VITE_FB_API_KEY'),
    authDomain: need('VITE_FB_AUTH_DOMAIN'),
    projectId: need('VITE_FB_PROJECT_ID'),
    storageBucket: need('VITE_FB_STORAGE_BUCKET'),
    messagingSenderId: need('VITE_FB_MESSAGING_SENDER_ID'),
    appId: need('VITE_FB_APP_ID'),
  },
  /** The v1 app's address, for the "open in TradeView office" links during the two-app period. */
  v1Url: (import.meta.env.VITE_TV_V1_URL as string) ?? 'https://trade-view.app',
} as const;
